import React from "react"

import styles from "./CheckModal.module.css"
import closeBtn from "../../assets/mobileClose.svg"

function CheckModal({ setCheckOpen, warning, text, onConfirm }) {

	const closeCheck = () => {
		setCheckOpen(false)
	}

	return (
		<>
			<div className={styles.modalWrap}>
				<div className={styles.checkModal}>
					<div className={styles.modalHeader}>
						<h2>안내</h2>
						<button type="button" onClick={closeCheck}>
							<img src={closeBtn} alt="팝업 닫기" />
						</button>
					</div>
					<div className={styles.modalText}>
						<span className={styles.red}>{warning}</span>
						<span>{text}</span>
					</div>
					<div className={styles.btnWrap}>
						<button type="submit" onClick={onConfirm}>
						확인
						</button>
						<button type="button" onClick={closeCheck}>
						취소
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default CheckModal
